export const GLYPHS = {
  adm: 'amazon',
  android: 'android',
  apns: 'ios',
  email: 'mail',
  ios: 'ios',
  gcm: 'android',
  sms: 'message',
};

export const NAMES = {
  adm: 'Amazon',
  android: 'Android',
  apns: 'iOS',
  email: 'Email',
  gcm: 'Android',
  ios: 'iOS',
  sms: 'Text',
};
